// Display · Avatar helpers
//
// Split out of `Avatar.tsx` so that module exports components only.

/** "Marek Nowak" → "MN", "Marek" → "M", "" → "?". */
export function avatarInitials(name: string | null | undefined): string {
  if (!name) return "?";
  const words = name.trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return "?";
  if (words.length === 1) return words[0][0].toUpperCase();
  return (words[0][0] + words[words.length - 1][0]).toUpperCase();
}
